import { formatter, request } from '@/utils/request';

export namespace ShipTo {
  export const Path = {
    Search: '/expenseapi/shipTo/search',
    AjaxSearch: '/expenseapi/shipTo/ajaxSearch',
    Query: '/expenseapi/shipTo/query',
    Export: '/expenseapi/shipTo/export',
    Get: '/expenseapi/shipTo/get',
    QueryForSoldTo: '/expenseapi/shipTo/queryForSoldTo',
    SearchExcel: '/expenseapi/shipTo/searchExcel',
    ajaxSearchYys: '/expenseapi/shipTo/ajaxSearchYys',
    ajaxSearchYyb: '/expenseapi/shipTo/ajaxSearchYyb',
    QueryForSelect: '/expenseapi/shipTo/queryForSelect',
  };

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.QueryResult<any>>>(Path.Query, formatter(options));
  }

  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.QueryResult<any>>>(Path.Export, formatter(options));
  }

  export async function search(body: API.ShipToFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.ShipTo[]>>(Path.Search, formatter(options));
  }

  export async function ajaxSearch(body: API.ShipToFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.ShipTo[]>>(Path.AjaxSearch, formatter(options));
  }

  export async function ajaxSearchYys(body: API.ShipToFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.Yys[]>>(Path.ajaxSearchYys, formatter(options));
  }

  export async function ajaxSearchYyb(body: API.ShipToFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.Yyb[]>>(Path.ajaxSearchYyb, formatter(options));
  }

  export async function get(id: string) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.ShipTo>>(Path.Get, formatter(options));
  }

  export async function queryForSoldTo(soldToCode: string) {
    const options = {
      method: 'GET',
      body: {
        soldToCode: soldToCode,
      },
    };
    return request<API.ResponseResult<any>>(Path.QueryForSoldTo, formatter(options));
  }

  export async function searchExcel(body: API.ShipToFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.ShipToExcel[]>>(Path.SearchExcel, formatter(options));
  }

  export async function queryForSelect(body: API.QueryForPageReq) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<any>>(Path.QueryForSelect, formatter(options));
  }
}
